import ZapPrefillGenerator from 'app/developer-v3/pages/embed/ZapPrefillGenerator';

export default {
  routes: {
    '.': ZapPrefillGenerator,
  },
};
